import React from 'react';

const icon8 = () => {
    return (
        <>
             <svg
                    width="30"
                    height="31"
                    viewBox="0 0 30 31"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M23.749 10.3203H6.24902C4.86831 10.3203 3.74902 11.4396 3.74902 12.8203V25.3203C3.74902 26.701 4.86831 27.8203 6.24902 27.8203H23.749C25.1297 27.8203 26.249 26.701 26.249 25.3203V12.8203C26.249 11.4396 25.1297 10.3203 23.749 10.3203Z"
                      stroke="white"
                      strokeWidth="2.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M14.999 6.57031C14.999 5.82863 14.7791 5.10361 14.367 4.48693C13.955 3.87024 13.3693 3.38959 12.6841 3.10577C11.9989 2.82194 11.2449 2.74767 10.5174 2.89237C9.79001 3.03706 9.12182 3.39422 8.59737 3.91866C8.07293 4.44311 7.71577 5.1113 7.57108 5.83873C7.42639 6.56615 7.50065 7.32015 7.78448 8.00538C8.06831 8.6906 8.54895 9.27627 9.16564 9.68833C9.78232 10.1004 10.5073 10.3203 11.249 10.3203"
                      stroke="white"
                      strokeWidth="2.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M18.749 10.3203C19.4907 10.3203 20.2157 10.1004 20.8324 9.68833C21.4491 9.27627 21.9297 8.6906 22.2136 8.00538C22.4974 7.32015 22.5717 6.56615 22.427 5.83873C22.2823 5.1113 21.9251 4.44311 21.4007 3.91866C20.8762 3.39422 20.208 3.03706 19.4806 2.89237C18.7532 2.74767 17.9992 2.82194 17.314 3.10577C16.6287 3.38959 16.0431 3.87024 15.631 4.48693C15.219 5.10361 14.999 5.82863 14.999 6.57031"
                      stroke="white"
                      strokeWidth="2.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M14.999 6.57031V27.8203"
                      stroke="white"
                      strokeWidth="2.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M26.249 19.0703H3.74902"
                      stroke="white"
                      strokeWidth="2.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
        </>
    );
};

export default icon8;